import React from "react";
import { Box } from "@mui/material";

const MDBox = ({
  variant = "contained",
  bgColor = "transparent",
  color = "dark",
  opacity = 1,
  borderRadius = "md",
  shadow = "none",
  coloredShadow = "none",
  children,
  sx,
  ...rest
}) => {
  return (
    <Box
      sx={{
        borderRadius: borderRadius === "md" ? "0.75rem" : borderRadius,
        backgroundColor: bgColor,
        color: color,
        opacity: opacity,
        boxShadow: shadow !== "none" ? shadow : "none",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default MDBox;
